<template>
  <div class="sauce-window-component">
    <h1 class="font-weight-regular">
      Выбор соуса к заказу:
    </h1>

    <div class="button-group d-flex justify-between">
      <v-row class="justify-space-between">
        <v-col sm="5">
          <v-btn
            class="button button-back"
            width="100%"
            color="#F1F3F6"
            @click="goBack"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
        <v-col sm="5">
          <v-btn
            class="button button-edit"
            width="100%"
            color="#F1F3F6"
            :loading="isLoading"
            @click="goToEdit"
          >
            <font-awesome-icon icon="edit" />
            Редактировать
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-row v-if="items.length" class="menu-items">
      <v-loader v-show="isLoading" absolute />
      <v-col v-for="(item, i) in items" :key="i" sm="3">
        <food-card
          :item="item"
          :is-drink="false"
          new
          bonus
          child
        />
      </v-col>
    </v-row>
    <span v-else class="d-block display-3 text-center">Ничего не найдено</span>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import FoodCard from '../food-card/FoodCard'
  import editSessionApi from '@/api/order/edit-session'

  export default {
    name: 'SauceWindow',
    components: {
      VLoader,
      FoodCard,
    },
    data () {
      return {
        items: [],
        currentFoodItem: {},
      }
    },
    computed: {
      ...mapState({
        orderId: state => state.fastOrder.orderId,
        isLoading: (state) => state.fastOrder.isMenuItemsLoading,
      }),
    },
    mounted () {
      this.getCategory()
    },
    methods: {
      goToEdit () {
        editSessionApi.open(this.orderId)
        this.$router.push({
          path: '/edit-order',
          query: {
            id: this.orderId,
          },
        })
      },
      getCategory () {
        const id = 11
        this.$store.dispatch('categories/fetchFilialMenuSingleCategories', { id })
          .then(res => {
            this.items = res.data.data.menuItems
          })
      },
      goBack () {
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
      },
    },
  }
</script>

<style lang="less" scoped>
  .sauce-window-component {
    background-color: transparent;

    h1 {
      font-size: 34px;
      line-height: 1;
      margin-bottom: 33px;
    }

    .menu-items {
      position: relative;
      z-index: 0;
    }

    .button {
      height: 80px;
      border-radius: 10px;

      svg {
        margin-right: 8px;
      }
    }

    .button-group {
      margin-bottom: 30px;

      .button {
        font-size: 15px;
        box-shadow: 0 3px 6px #00000029 !important;
      }

      .button-back {
        svg {
          .fill-svg(#0033ff);
        }
      }

      .button-edit {
        color: @color-primary;

        svg {
          .fill-svg(@color-primary);
        }
      }
    }
  }
</style>
